import { ReactElement } from 'react'

import CLButton from 'syf-component-library/ui/atoms/Button/Button'
import { Button as BrandRefreshButton } from '@syf-cl/button'
import { useAccountSummary } from 'const/syfApiQueries'
import i18n from 'strings/i18n'
import { Account } from '@syf-api-library/credit-accounts'

import { creditBalanceRefundModalContainerId } from 'const/modalContainerId'
import { useSetAtom } from 'jotai'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'
import { setAnalyticsDefaults } from 'helpers/triggerAnalyticsEvent'
import { isBrandRefreshEnabled } from 'helpers/getBrandRefreshPhase'

interface CreditBalanceRefundButtonProps {
  account: Account
  className?: string
  dataType?: string
}

const CreditBalanceRefundButton = ({
  account,
  className,
  dataType
}: CreditBalanceRefundButtonProps): ReactElement => {
  const setSelectedAccount = useSetAtom(selectedAccountAtom)
  const updateModalStatus = useSetAtom(modalStatusAtom)

  const accountId = account?.info['cipher.accountId']
  const { data: { product } = {} } = useAccountSummary(accountId)
  const manageCreditBalanceRefundButtonId =
    creditBalanceRefundModalContainerId(accountId)

  const handleOnClick = () => {
    setAnalyticsDefaults({
      Product: product?.type,
      ClientName: product?.clientId
    })
    setSelectedAccount(accountId)

    updateModalStatus('CreditBalanceRefund', manageCreditBalanceRefundButtonId)
  }

  const brandRefreshEnabled = isBrandRefreshEnabled()
  const RefundButton: React.ElementType = brandRefreshEnabled
    ? BrandRefreshButton
    : CLButton
  const variantProps = brandRefreshEnabled
    ? { variant: 'secondary' }
    : { buttonType: 'secondary' }

  return (
    <RefundButton
      {...variantProps}
      className={className}
      onClick={handleOnClick}
      data-type={dataType || 'manage credit balance'}
      data-reason="manage credit balance"
      data-analytics="clicktrackingevent"
      data-test="manage-credit-balance-button"
    >
      {i18n({ button: 'creditBalanceRefund' })}
    </RefundButton>
  )
}

export default CreditBalanceRefundButton
